// ENTITY fr.gestionpial.pial.dto.EmploiDuTempsNotificationDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { Ecole } from './Ecole';
import { Classe } from './Classe';
import { CreneauAffectation } from './CreneauAffectation';
import { EmploiDuTempsLookupsDTO } from './EmploiDuTempsLookupsDTO';
import { Notification } from './Notification';

export class EmploiDuTempsNotificationDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.EmploiDuTempsNotificationDTO';

  notification: Notification | null = null;
  classe: Classe | null = null;
  ecole: Ecole | null = null;
  creneaux: CreneauAffectation[] | null = [];
  creneauxAutres: CreneauAffectation[] | null = [];
  lookups: EmploiDuTempsLookupsDTO | null = null;

  constructor(init?:Partial<EmploiDuTempsNotificationDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.EmploiDuTempsNotificationDTO'] = EmploiDuTempsNotificationDTO;

fields['fr.gestionpial.pial.dto.EmploiDuTempsNotificationDTO']  = {
    notification: 'fr.gestionpial.pial.entities.Notification',
    classe: 'fr.gestionpial.pial.entities.Classe',
    ecole: 'fr.gestionpial.pial.entities.Ecole',
    creneaux: 'java.util.List<fr.gestionpial.pial.entities.CreneauAffectation>',
    creneauxAutres: 'java.util.List<fr.gestionpial.pial.entities.CreneauAffectation>',
    lookups: 'fr.gestionpial.pial.dto.EmploiDuTempsLookupsDTO'
};
